<template>
  <section class="form-section">
    <div class="form-section__head">
      <h3>기부 정보</h3>
    </div>
    <div>
      <dl class="form-list__row">
        <dt class="form-list__key">
          기부자명          
        </dt>
        <div class="div-checkedSameName">
           <DxCheckBox
              text="고객명과 동일  "
              v-model="checkedSameName"
              :disabled="isRegDone"
              @valueChanged="handleCheckedSameName"
            />

            <DxCheckBox
              text="무기명 기부 신청"
              v-model="checkedNoName"
              :disabled="isRegDone"
              @valueChanged="handleNoName"
            />
        </div>
            
        <dd>
        <DxValidationGroup ref="validationGroup2">
          <div class="agrm-form-input-area">
            <DxTextBox
              ref="txtBox3"
              placeholder="이름을 입력해주세요"
              :disabled="isRegDone || checkedSameName || checkedNoName"
              v-model="dntnParams.dntnCstmNm">
              <DxValidator>
                  <DxRequiredRule message="기부자명을 입력해주세요" />
                </DxValidator>
            </DxTextBox>
          </div>
        </DxValidationGroup>  
        </dd>
      </dl>
      <dl class="form-list__row">
        <dt class="form-list__key">
         주민등록번호(세액공제용)
        </dt>
        <dd>
        <DxValidationGroup ref="validationGroup3">
          <div class="agrm-form-input-area">
            <DxTextBox
              ref="txtBox4"
              placeholder="주민등록번호를 입력해주세요 (- 없이 입력)"
              :disabled="isRegDone  || checkedNoName"
              maxLength="13"
              v-model="dntnParams.dntnCstmIdntNum">
              <DxValidator>
                  <DxRequiredRule message="주민번호를 입력해주세요" />
                </DxValidator>
            </DxTextBox>
          </div>
        </DxValidationGroup>    
          <div class="form-guide-text">
             세액공제를 위해 주민등록번호가 필요합니다<br/>입력을 원하지 않으시면 '무기명 기부 신청'에 체크해 주세요
          </div>
        </dd>
      </dl>
    </div>
  </section>
</template>

<script>
import DxTextBox from 'devextreme-vue/text-box'
import { DxCheckBox } from "devextreme-vue/check-box";
import DxValidationGroup from 'devextreme-vue/validation-group'
import {
  DxValidator,
  DxRequiredRule
} from 'devextreme-vue/validator'

export default {
  name: 'Donate',
  components: {
    DxCheckBox,
    DxTextBox,
    DxValidator,
    DxRequiredRule,
    DxValidationGroup
  },
  props: [
  	'isRegDone',
    'isPassYn',
    'isForeigner',
    'orgCstmNm',
    'temp_om_account',
    'bankCdList',
    'ordInfo'
  ],
  data: () => ({
    om_account_value: '',
    dntnParams: {
      	dntnCstmNm: '',
    	dntnCstmIdntNum: ''
    },
    key:'',
    eventNm:'',
    checkedSameName: false,
    checkedNoName: false
  }),
  watch: {
  	dntnParams: {
      deep: true,
      handler (newVal) {
        this.$emit('changeDntnInfo', newVal)
      }
    },
  },
  created () {
  	this.dntnParams.dntnCstmNm = this.ordInfo.dntnCstmNm
    this.dntnParams.dntnCstmIdntNum = this.ordInfo.dntnCstmIdntNum == null ? '':this.ordInfo.dntnCstmIdntNum
  },
  mounted () {
      this.validation2()
      this.validation3()
  },
  methods: {
    certPass (e) {
      this.$emit('certPass')
    },
    validation2 (e) {
      this.$emit('validation2' , this.$refs['validationGroup2'] , this.$refs['txtBox3'])
    },
     validation3 (e) {
      this.$emit('validation3' , this.$refs['validationGroup3'] , this.$refs['txtBox4'])
    },
    handleSelectBoxClick (isOpened) {
      if (isOpened) {
        document.body.id = 'TalkDepositNew'
        return
      }
      if (!isOpened && document.body.id === 'TalkDepositNew') {
        document.body.id = ''
      }
    },
    handleCheckedSameName(e){
      const { value, event } = e;
      if(value){
        this.checkedNoName = false;
        this.dntnParams.dntnCstmNm = this.orgCstmNm;
      }
    },
    handleNoName(e){
      const { value, event } = e;
      if(value){
        this.checkedSameName = false;
        this.dntnParams.dntnCstmNm = '무기명';
        this.dntnParams.dntnCstmIdntNum = '';
      }
    },
    formatNameInput(e){
      this.$emit('changeDntnInfo', {dntnCstmNm:this.dntnParams.dntnCstmNm ,dntnCstmIdntNum:this.dntnParams.dntnCstmIdntNum});
    },
    formatOnkey(e) {
        this.key = e.event.key
        const t = '0123456789'
        var changed = true

        if(e.event.originalEvent.key == undefined) {
         	this.key = e.event.originalEvent.data
         	this.eventNm = this.eventNm == '' ? 'input' : this.eventNm
        } else {
        	this.eventNm = this.eventNm == '' ? 'on' : this.eventNm
        }

        if(this.key == 'Backspace' || this.key == null) {
        	this.dntnParams.formatDntnCstmIdntNum = this.dntnParams.formatDntnCstmIdntNum.substring(0,this.dntnParams.formatDntnCstmIdntNum.length-1)
        	 if(this.dntnParams.formatDntnCstmIdntNum.length <= 7) {
	    		this.dntnParams.formatDntnCstmIdntNum = this.dntnParams.formatDntnCstmIdntNum.replace('-','')
	    	}
        } else if(t.indexOf(this.key) != -1){
        	this.dntnParams.formatDntnCstmIdntNum = this.dntnParams.formatDntnCstmIdntNum + this.key
        } else if(this.key.length > 1) {
        	this.dntnParams.formatDntnCstmIdntNum = this.dntnParams.formatDntnCstmIdntNum
        	changed = false
        } else {
        	this.dntnParams.formatDntnCstmIdntNum = this.dntnParams.formatDntnCstmIdntNum + this.key
        }
        
        if(this.dntnParams.formatDntnCstmIdntNum.length == 7) {
	    		this.dntnParams.formatDntnCstmIdntNum = this.dntnParams.formatDntnCstmIdntNum.substring(0,6) 
	    		+ '-' + this.dntnParams.formatDntnCstmIdntNum.substring(6, this.dntnParams.formatDntnCstmIdntNum.length)
	     }
	     if(this.dntnParams.formatDntnCstmIdntNum.length >= 9) {
    		this.dntnParams.formatDntnCstmIdntNum = this.dntnParams.formatDntnCstmIdntNum.substring(0,this.dntnParams.formatDntnCstmIdntNum.length-1) + '●'
    	 }
    	 if(this.dntnParams.formatDntnCstmIdntNum.length >= 14){
        	this.dntnParams.formatDntnCstmIdntNum = this.dntnParams.formatDntnCstmIdntNum.substring(0,14)
         }
         changed = this.dntnParams.bfrFormatDntnCstmIdntNum.length != this.dntnParams.formatDntnCstmIdntNum.length ? true : false

         if(changed) {
         	if(this.dntnParams.bfrFormatDntnCstmIdntNum.length >= this.dntnParams.formatDntnCstmIdntNum.length) {
        	this.dntnParams.dntnCstmIdntNum = this.dntnParams.dntnCstmIdntNum.substring(0,this.dntnParams.dntnCstmIdntNum.length-1)
	        } else {
	        	this.dntnParams.dntnCstmIdntNum = this.dntnParams.dntnCstmIdntNum 
	        	+ this.key
	        }
	         this.$emit('changeDntnInfo', {dntnCstmNm:this.dntnParams.dntnCstmNm ,dntnCstmIdntNum:this.dntnParams.dntnCstmIdntNum});
	        this.dntnParams.bfrFormatDntnCstmIdntNum = this.dntnParams.formatDntnCstmIdntNum 
         }

        return
    }
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/purchase/sale/components/NewDonate.vue